import React from 'react';
import { canAccessQCModule } from '../../utils/roleConstants';
import { Form, FormGroup, FormControl, Button, Modal, Row, Col } from 'react-bootstrap';
import config from '../../../config';
import DataTable from 'react-data-table-component';
import { Navigate } from 'react-router';
import ReactPaginate from 'react-paginate';
import moment from 'moment';
import utils from '../../utils';
import DataTableEllipsisText from '../../_components/DataTableEllipsisText';
import DatacoLoadingIndicator from '../../_components/DatacoLoadingIndicator';

let perPage=30;

class InspectionList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            id: 0,
            requirement: '',
            label: '',
            remark: '',
            company: 0,
            offset: 0,
            currentPage: 1,
            rowsPerPage: 10,
            totalRows: 0,
            loading: false,
        };
        this.tableRequestSeq = 0;

          this.columns = [
            {
                name: 'No',
                selector: row => row.no,
            },
            {
                name: 'Requirement',
                selector: row => row.requirement,
                cell: row => <DataTableEllipsisText value={row.requirement} />,
                sortable: true,
            },
            {
                name: 'Label',
                selector: row => row.label,
                cell: row => <DataTableEllipsisText value={row.label} />,
                sortable: true,
            },
                {
                name: 'Remark',
                selector: row => row.remark,
                cell: row => <DataTableEllipsisText value={row.remark} />,
                sortable: true,
            },
            {
                name: 'Action',
                cell: (row, rowIndex) => (
                  <div style={{ display: 'flex', gap: '10px', flexWrap: 'nowrap', minWidth: '200px' }}>
              <button
                    style={{ whiteSpace: 'nowrap', minWidth: '70px', padding: '6px 12px', fontSize: '14px', fontWeight: '500', flexShrink: 0 }}
                    type="button"
                    onClick={() =>
                        this.onClickListSelected(null, row, rowIndex)}
                >
                    Edit
            </button>
                <button
                    style={{ whiteSpace: 'nowrap', minWidth: '70px', padding: '6px 12px', fontSize: '14px', fontWeight: '500', flexShrink: 0 }}
                    type="button"
                    onClick={() =>
                        window.confirm("Are you sure you delete this data?") && this.onDeleteList(null, row, rowIndex)}
                >
                    Delete
          </button>
            </div>
                ),
                ignoreRowClick: true,
                allowOverflow: true,
                width: '200px',
                minWidth: '200px',
            }];
    }

    componentWillMount() {

        this.setState({
            processes: []
        });
        const requestOptions = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
        };
        this.buildHtmlTable();
    }

    exportExcel() {
        utils.tableToExcel('datatable', 'masterdata', 'Inspection_List_' + moment().format('YYYYMMDD') + '.xls');
    };


    buildHtmlTable(page = null, limit = null) {
        const { tableStyle, tableHeader } = this.state;
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
        };

        // Use provided page/limit or state values
        const currentPage = page !== null ? page : this.state.currentPage;
        const rowsPerPage = limit !== null ? limit : this.state.rowsPerPage;
        const offset = (currentPage - 1) * rowsPerPage;
        const requestSeq = ++this.tableRequestSeq;
        this.setState({ loading: true });

        if (localStorage.getItem('user') != null)
            return fetch(`${config.apiUrl}/getInspectionListByCompany?company=${JSON.parse(localStorage.getItem('user')).accountId}&keyword=${this.state.keyword || ''}&limit=${rowsPerPage}&offset=${offset}`, requestOptions)
                .then((response) => {
                    return response.text().then(text => {
                        const data = text && JSON.parse(text);

                        return data;
                    });
                })
                .then(body => {
                    if (requestSeq !== this.tableRequestSeq) return;

                    // login successful if there's a user in the response
                    let array = [];
                    const list = [];

                    // Ensure body.data exists and is an array
                    if (body && body.data && Array.isArray(body.data)) {
                        const currentPage = page !== null ? page : this.state.currentPage;
                        const rowsPerPage = limit !== null ? limit : this.state.rowsPerPage;
                        const offset = (currentPage - 1) * rowsPerPage;

                        body.data.map((data, index) => {
                            array.push({
                                no: index + offset + 1,
                                id: data.id,
                                requirement: data.requirement,
                                label: data.label,
                                remark: data.remark,
                                company: data.companyId
                            })
                        });

                        this.setState({ 
                            list: array,
                            body: body.data,
                            totalRows: body.meta && body.meta.total_count ? body.meta.total_count : 0,
                            currentPage: currentPage,
                            rowsPerPage: rowsPerPage,
                            offset: offset,
                            loading: false
                        });
                    } else {
                        this.setState({ 
                            list: [],
                            body: [],
                            totalRows: 0,
                            loading: false
                        });
                    }
                })
                .catch(error => {
                    if (requestSeq === this.tableRequestSeq) {
                        console.error('Error fetching inspection list:', error);
                        this.setState({ list: [], body: [], totalRows: 0, loading: false });
                    }
                });
    }

      onClickListSelected(cell, row, rowIndex) {
          // Find the record in body by matching id
          const record = this.state.body.find(r => r.id === row.id) || (row.id ? row : null);
          if (!record) {
              return;
          }
          this.setState({ modalShow: true });
          this.setState({ newMode: false });
          this.setState({ requirement: record.requirement });
          this.setState({ label: record.label });
          this.setState({ remark: record.remark });

          this.setState({ id: record.id });
          this.setState({ companyId: record.company });

    }

    onDeleteList(cell, row, rowIndex) {
        // Find the record in body by matching id, or use row.id directly
        const recordId = row && row.id ? row.id : (this.state.body && this.state.body[rowIndex] ? this.state.body[rowIndex].id : null);
        if (!recordId) {
            return;
        }
        fetch(`${config.apiUrl}/deleteInspection`, {
            method: "post",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },

            //make sure to serialize your JSON body
            body: JSON.stringify({
                id: recordId,
            })
        })
            .then((response) => {
                if (response.status == 200) {
                    window.alert('Deleted Successfully.');
                    this.buildHtmlTable();
                }
            });
    }

    cellButton(cell, row, enumObject, rowIndex) {
        return (
            <div>
              <button
                    style={{ marginRight: 10 }}
                    type="button"
                    onClick={() =>
                        this.onClickListSelected(cell, row, rowIndex)}
                >
                    Edit
            </button>
                <button
                    style={{ marginRight: 10 }}
                    type="button"
                    onClick={() =>
                        window.confirm("Are you sure you delete this data?") && this.onDeleteList(cell, row, rowIndex)}
                >
                    Delete
          </button>
            </div>
        )
    }

    handlePageChange = (page) => {
        this.setState({ currentPage: page }, () => {
            this.buildHtmlTable(page, this.state.rowsPerPage);
        });
    };

    handleRowsPerPageChange = (newRowsPerPage, page) => {
        this.setState({ rowsPerPage: newRowsPerPage, currentPage: page }, () => {
            this.buildHtmlTable(page, newRowsPerPage);
        });
    };


     handleChange (event, newValue) {
        this.setState({ tabvalue: newValue });
    }

      
    render() {
        const user = JSON.parse(localStorage.getItem('user'));
        if (!canAccessQCModule(user)) {
            return <Navigate to='/' />
        }
        let { keyword,list,modalShow, newMode, requirement, label, remark } = this.state;
        let handleClose = () => this.setState({ modalShow: false });
             let handleSave = () => {
                    window.confirm("Are you sure you update this data?") && fetch(`${config.apiUrl}/updateInspection`, {
                        method: "post",
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json'
                        },

                        //make sure to serialize your JSON body
                        body: JSON.stringify({
                            requirement,
                            label,
                            remark,
                            id: this.state.id,
                        })
                    })
                .then((response) => {
                    if (response.status == 200) {
                        window.alert('Update Successfully.');

                        this.setState({ modalShow: false });
                        this.buildHtmlTable();
                    }
                });
        }
        let handleCreate = () => {
            fetch(`${config.apiUrl}/uploadInspection`, {
                method: "post",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },

                //make sure to serialize your JSON body
                body: JSON.stringify({
                    requirement,
                    label,
                    remark,
                    companyId: JSON.parse(localStorage.getItem('user')).accountId,
                })
            })
                .then((response) => {
                    if (response.status == 200) {
                        this.setState({ modalShow: false });
                        this.setState({ newMode: false });
                        window.alert('New data created successfully.');
                        this.buildHtmlTable();
                    }
                });
        }
        return (
            <div class="container">
                <div style={{ 
                    marginBottom: '20px', 
                    position: 'relative', 
                    minHeight: '50px',
                    padding: '16px',
                    margin: '16px 0'
                }}>
                    <div style={{ 
                        display: 'flex', 
                        alignItems: 'center', 
                        gap: '10px', 
                        flexWrap: 'wrap',
                        padding: '12px'
                    }}>
                        <FormGroup controlId="formInlineName">
                            <FormControl 
                                type="text" 
                                placeholder="Search..." 
                                onChange={ev => { this.setState({ keyword: ev.target.value }) }} 
                                value={keyword || ''} 
                                style={{ minWidth: '200px' }}
                            />
                        </FormGroup>
                        <Button
                            bsStyle="primary"
                            onClick={e => {
                                this.setState({ currentPage: 1, offset: 0 }, () => {
                                    this.buildHtmlTable(1, this.state.rowsPerPage);
                                });
                            }}>Search</Button>
                        <Button
                            bsStyle="primary"
                            onClick={e => this.exportExcel()}>Export</Button>
                        <Button
                            style={{ marginLeft: 'auto' }}
                            bsStyle="danger"
                            onClick={e => { this.setState({ modalShow: true }); this.setState({ newMode: true }); }}>New</Button>
                    </div>
                    <a id='dlink' style={{ display: 'none' }}></a>
                </div>
                <div id="datatable" class="container" style={{ overflowY: 'auto' }} >
                    <DataTable
                    columns={this.columns}
                    data={list || []}
                    progressPending={this.state.loading}
                    progressComponent={<DatacoLoadingIndicator loading={this.state.loading} size="compact" label="Loading inspection list" />}
                    pagination
                    paginationServer
                    paginationTotalRows={this.state.totalRows}
                    paginationPerPage={this.state.rowsPerPage}
                    paginationDefaultPage={this.state.currentPage}
                    onChangePage={this.handlePageChange}
                    onChangeRowsPerPage={this.handleRowsPerPageChange}
                    highlightOnHover
                />
                </div>
                     <Modal size="lg" show={modalShow} onHide={handleClose}
                                    aria-labelledby="example-modal-sizes-title-lg" dialogClassName="modal-90w">
                                    <Modal.Header closeButton>
                                        {newMode ? (<Modal.Title>New Inspection</Modal.Title>) : (<Modal.Title>Edit Inspection Data</Modal.Title>)}
                                    </Modal.Header>
                                    <Modal.Body>
                                        <div>
                                            <Form>
                                                <FormGroup className="row" as={Row} controlId="formInlineCustomer" style={{ marginBottom: '15px' }}>
                                                    <Col sm={6}><Form.Label>Requirement</Form.Label></Col>
                                                    <Col sm={6}><FormControl type="text" onChange={ev => { this.setState({ requirement: ev.target.value }) }} value={requirement} /></Col>
                                                    <Col sm={6}><Form.Label>Label</Form.Label></Col>
                                                    <Col sm={6}><FormControl type="text" onChange={ev => { this.setState({ label: ev.target.value }) }} value={label} /></Col>
                                                     <Col sm={6}><Form.Label>Remark</Form.Label></Col>
                                                    <Col sm={6}><FormControl type="text" onChange={ev => { this.setState({ remark: ev.target.value }) }} value={remark} /></Col>
                                                </FormGroup>
                                               
                                            </Form>
                                        </div>
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <Button variant="secondary" onClick={handleClose}>
                                            Cancel
                            </Button>
                                        {newMode && (<Button variant="primary" onClick={handleCreate}>
                                            Create
                            </Button>)}
                
                                        {!newMode && (<Button variant="primary" onClick={handleSave}>
                                            Save Changes
                            </Button>)}
                                    </Modal.Footer>
                                </Modal>
            </div>

        );
    }
}

export { InspectionList };
